import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { LiveKitRoom, VideoConference, RoomAudioRenderer, StartAudio } from "@livekit/components-react";
import "@livekit/components-styles";

const API = process.env.REACT_APP_BACKEND_URL;

// Open the native in-app video meeting modal from anywhere: openNativeMeeting("nt-meet-xxxx")
export const openNativeMeeting = (room) => window.dispatchEvent(new CustomEvent("nt-open-meeting", { detail: { room } }));

export default function NativeMeeting({ room, onClose }) {
  const [join, setJoin] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let live = true;
    fetch(`${API}/api/livekit/meet/join`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ room }),
    })
      .then(async (r) => {
        const b = await r.json();
        if (!r.ok) throw new Error(typeof b.detail === "string" ? b.detail : "Could not join the meeting");
        if (live) setJoin(b);
      })
      .catch((e) => live && setError(e.message));
    return () => {
      live = false;
    };
  }, [room]);

  return (
    <div className="fixed inset-0 z-[80] bg-[#111827]/95 flex items-center justify-center p-3 sm:p-6" data-testid="native-meeting">
      <div className="w-full max-w-4xl h-[80dvh] bg-black rounded-3xl overflow-hidden relative border border-[#374151]">
        <button onClick={onClose} data-testid="native-meeting-close" className="absolute top-3 right-3 z-10 w-9 h-9 bg-white/90 rounded-full flex items-center justify-center text-[#374151] shadow hover:bg-white transition-colors">
          <X className="w-4 h-4" />
        </button>
        {error ? (
          <div className="h-full flex items-center justify-center text-center p-8" data-testid="native-meeting-error">
            <p className="text-sm font-bold text-rose-300">{error}</p>
          </div>
        ) : !join ? (
          <p className="h-full flex items-center justify-center text-sm font-bold text-[#9CA3AF]">Connecting to video room…</p>
        ) : (
          <LiveKitRoom token={join.token} serverUrl={join.serverUrl} connect video audio={false} onDisconnected={onClose} style={{ height: "100%" }}>
            <VideoConference />
            <RoomAudioRenderer />
            <StartAudio label="Enable audio" />
          </LiveKitRoom>
        )}
      </div>
    </div>
  );
}
